import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { WhistleBlowingPolicyPageContent } from "./WhistleBlowingPolicyPageContent";
import { WhistleBlowingPolicyPageHeading } from "./WhistleBlowingPolicyPageHeading";
import { WhistleBlowingPolicyNextPage } from "./WhistleBlowingPolicyNextPage";

export const WhistleBlowingPolicy = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "whistleblowingPolicyPageHeading",
      children: <WhistleBlowingPolicyPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "whistleblowingPolicyPageContent",
      children: <WhistleBlowingPolicyPageContent/>
    },
    {
      label: "Next Page",
      key: "whistleblowingPolicyNextPage",
      children: <WhistleBlowingPolicyNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
